<template>
    <div class="c-command-right">
        <el-dropdown class="c-command-right-dropdown-trigger" trigger="click" placement="bottom">
            <div class="dropdown-container">
                <top-tabs :tabsObj="tabsObj" class="dropdown-top-tabs"></top-tabs>
                <i class="el-icon-arrow-down el-icon-arrow-down dropdown-arrow"></i>
                <div class="dropdown-overlay"></div>
            </div>
            <el-dropdown-menu class="c-command-right-dropdown" slot="dropdown">
                <el-dropdown-item @click.native="dropdownFn('statistics')">{{ $t('yingji.rightIndex.dataStatistics') }}</el-dropdown-item>
                <el-dropdown-item @click.native="dropdownFn('caseInfo')">{{ $t('yingji.rightIndex.caseInfo') }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <template v-if="titleStatus">
            <div class="dropdown-content-container">
                <RightAside></RightAside>
            </div>
        </template>
        <template v-else>
            <RightCase :rightShow="rightShow" @selectCaseId="getSelectCaseId" @update:startDate="handleUpdateStartDate" @update:endDate="handleUpdateEndDate" :caseListAll="allCeseList" :startDate="startDate" :endDate="endDate"></RightCase>
        </template>
    </div>
</template>

<script>
import TopTabs from '@/components/topTabs.vue';
import RightAside from './RightAside.vue';
import RightCase from './RightCase.vue';

export default {
    props: {
        rightShow: {
            type: Boolean,
            default: true,
        },
        selectCaseId: {
            type: Function,
        },
        allCeseList: {
            type: Array,
            default: () => [],
        },
        startDate: {
            type: String,
            default: null,
        },
        endDate: {
            type: String,
            default: null,
        },
    },
    emits: [
        'selectCaseId',
        'update:startDate',
        'update:endDate',
    ],
    components: {
        RightAside,
        RightCase,
        TopTabs,
    },
    data () {
        return {
            titleStatus: true,
            _centreKey: 'statistics',
        };
    },
    computed: {
        tabsObj() {
            const key = this._centreKey;
            return {
                centre: this.$t(key === 'statistics' ? 'yingji.rightIndex.dataStatistics' : 'yingji.rightIndex.caseInfo'),
                type: 3,
            };
        },
    },
    watch: {
        _centreKey (val) {
            this.titleStatus = val === 'statistics';
        },
        allCeseList (newval, oldval) {
            if (this.allCeseList.length > 0) {
                this._centreKey = 'caseInfo';
            } else {
                this._centreKey = 'statistics';
            }
        },
    },
    methods: {
        dropdownFn (val) {
            this._centreKey = val === 'caseInfo' ? 'caseInfo' : 'statistics';
        },
        // eslint-disable-next-line vue/no-dupe-keys
        getSelectCaseId(id) {
            this.$emit('selectCaseId', id);
        },
        handleUpdateStartDate(startDate) {
            this.$emit('update:startDate', startDate);
        },
        handleUpdateEndDate(endDate) {
            this.$emit('update:endDate', endDate);
        },
    },
};
</script>
<style lang="scss">
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

.c-command-right {
    height: 100%;
}

.c-command-right-dropdown-trigger {
    width: 100%;
}

.dropdown-container {
    position: relative;
    font-size: 18px;
    color: #fff;
}

.dropdown-top-tabs {
    border-radius: 16px 16px 0px 0px;
}

.dropdown-arrow {
    position: absolute;
    right: 100px;
    top: 20px;
}

.dropdown-overlay {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
    z-index: 2;
}

.dropdown-content-container {
    height: calc(100% - 50px);
}

.c-command-right-dropdown.el-dropdown-menu {
    background: #071150;
    box-shadow: inset 0px 1px 8px 0px #1343c3;
    border: 1px solid #1343c3;
    border-radius: 3px 3px 3px 3px;
    color: #fff;

    @include themify($zhongke) {
        background: #0a241c;
        box-shadow: inset 0px 1px 8px 0px #1e9a74;
        border: 1px solid #008059;
    }

    .el-dropdown-menu__item {
        text-align: center;
        color: #fff;
        width: 288px;
        line-height: 40px;

        &:hover {
            background: #1343c3;

            @include themify($zhongke) {
                background: #1e9a74;
            }
        }
    }

    .popper__arrow::after {
        border-bottom-color: #1343c3;

        @include themify($zhongke) {
            border-bottom-color: #008059;
        }
    }
}
</style>
